var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/isarray/index.js
// module id = 315
// module chunks = 2